import * as React from 'react'
function SvgEditDoc(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M16 4c1.2 0 2 .8 2 2s-.8 2-2 2H8v24h24v-8c0-1.2.8-2 2-2s2 .8 2 2v10c0 1.2-.8 2-2 2H6c-1.2 0-2-.8-2-2V6c0-1.2.8-2 2-2zm13.4.6c.8-.8 2-.8 2.8 0l3.2 3.2c.8.8.8 2 0 2.8L22 24h-6v-6z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgEditDoc
